<template>
    <div>
        <b-form-group label-for="dias" class="mt-2">
            <b-form-group class="form-check form-check-inline">
                <b-form-checkbox v-model="workMaintainedCompetition" :value="1" :disabled="disabled">
                    Trabajos de mantenimiento
                </b-form-checkbox>
            </b-form-group>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        workMaintainedCompetition: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localWorkMaintainedCompetition: this.workMaintainedCompetition,
        }
    },
    watch: {
        workMaintainedCompetition(newVal) {
            this.localWorkMaintainedCompetition = newVal
            this.$emit('update', { work_maintained_competition: this.localWorkMaintainedCompetition })
        },
    },
}
</script>
